export default "__VITE_ASSET__BaBov7_r__"